import { CalendarClock, Calendar, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SchedulerTab = ({
  scheduledPosts, setScheduledPosts,
  SCHEDULER_COST
}) => (
  <div className="space-y-6">
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-xl bg-gradient-to-r from-blue-500 to-cyan-600">
            <CalendarClock className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-800 dark:text-white">Post Scheduler</h2>
            <p className="text-gray-500 text-sm">Schedule posts to auto-publish on your connected accounts</p>
          </div>
        </div>
        <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-medium">{SCHEDULER_COST} credits/mo</span>
      </div>

      <div className="mb-6">
        <h3 className="font-medium text-gray-700 dark:text-gray-300 mb-3">Scheduled Queue</h3>
        {scheduledPosts.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <CalendarClock className="h-12 w-12 mx-auto mb-3 text-slate-300" />
            <p>No scheduled posts yet</p>
            <p className="text-sm">Go to Library and click Schedule on any generation</p>
          </div>
        ) : (
          <div className="space-y-3">
            {scheduledPosts.map(post => (
              <div key={post.id} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-blue-100">
                    <Calendar className="h-4 w-4 text-blue-600" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-800 dark:text-white">{post.prompt?.substring(0, 40) || "Scheduled Post"}...</p>
                    <p className="text-sm text-gray-500">
                      {new Date(post.scheduled_for).toLocaleDateString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                      {" \u2022 "}{post.platform}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`text-xs px-2 py-1 rounded ${post.status === "pending" ? "bg-amber-100 text-amber-700" : "bg-green-100 text-green-700"}`}>
                    {post.status}
                  </span>
                  <Button size="sm" variant="outline" onClick={() => setScheduledPosts(prev => prev.filter(p => p.id !== post.id))}>
                    <Trash2 className="h-3 w-3" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
        <p className="text-sm text-blue-700">
          <strong>Tip:</strong> To schedule a post, go to your Library, select a generation, and click the Schedule button.
        </p>
      </div>
    </div>
  </div>
);
